// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { TableCell, TableRow } from '@mui/material'
import noop from 'lodash/noop'
import omit from 'lodash/omit'
import React from 'react'
import { Mutation } from 'react-apollo'
import DeleteButton from '../../../common/iconButtons/DeleteButton'
import EditButton from '../../../common/iconButtons/EditButton'
import RestrictedView from '../../auth/RestrictedView'
import { deleteToiletCheckQuestionMutation, toiletCheckQuestionsQuery } from './toiletCheckQuestionQueries'
import css from './toiletCheckQuestionTable.css'
import type { ToiletCheckQuestion } from './toiletCheckQuestionTypes'

const updateCacheOnDelete = (id: string, stationId?: string) => (cache: any) => {
  const variables = stationId
    ? {
        stationId,
      }
    : {}
  const { toiletCheckQuestions } = cache.readQuery({
    query: toiletCheckQuestionsQuery,
    variables,
  })
  cache.writeQuery({
    query: toiletCheckQuestionsQuery,
    variables,
    data: {
      toiletCheckQuestions: [...toiletCheckQuestions.filter((toiletCheckQuestion) => toiletCheckQuestion.id !== id)],
    },
  })
}

type Props = {
  data: ToiletCheckQuestion
  onEdit: (...args: Array<any>) => any
}

class ToiletCheckQuestionRow extends React.PureComponent<Props> {
  onDelete = (onMutate: (...args: Array<any>) => any, id: string) => {
    const { stationId } = this.props
    onMutate({
      variables: {
        id,
      },
      update: updateCacheOnDelete(id, stationId),
    })
  }

  render() {
    const { data, onEdit } = this.props
    return (
      <TableRow>
        <TableCell className={css.tableCell}>{data.description}</TableCell>
        <TableCell className={css.actionsCell} align='right'>
          <RestrictedView requiredPermission='manage_ownStation'>
            <EditButton
              className={css.actionButton}
              onClick={() => (data.id ? onEdit(omit(data, ['__typename'])) : noop)}
            />
            <Mutation mutation={deleteToiletCheckQuestionMutation}>
              {(onMutate) => (
                <DeleteButton
                  data-testid='deleteToiletCheckQuestion'
                  className={css.actionButton}
                  onClick={() => (data.id ? this.onDelete(onMutate, data.id) : noop)}
                />
              )}
            </Mutation>
          </RestrictedView>
        </TableCell>
      </TableRow>
    )
  }
}

export default ToiletCheckQuestionRow
